const colorsElements = require('./colors-elements-deprecated');

module.exports = colorsElements;
